import React, { useState } from 'react';
import { Box, TextField, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UploadImageInput from '../atom/UploadImageInput';
import { getFullImageUrl } from '../../helpers/imageUtils';

const InlineImageInput = ({ onInsert, onCancel }) => {
    const { t } = useTranslation();
    const [uploadedImage, setUploadedImage] = useState('');
    const [manualUrl, setManualUrl] = useState('');

    const handleSubmit = () => {
        if (!isValid) return;
        const selectedImagePath = uploadedImage || manualUrl;
        if (selectedImagePath.trim()) {
            const fullImageUrl = getFullImageUrl(selectedImagePath.trim());
            onInsert({ url: fullImageUrl });
        }
    };

    const handleManualUrlChange = (e) => {
        setManualUrl(e.target.value);
        // Clear uploaded image when manually entering URL
        setUploadedImage('');
    };

    const handleUploadedImageChange = (imageUrl) => {
        setUploadedImage(imageUrl === null ? '' : imageUrl);
        // Clear manual URL when image is uploaded
        setManualUrl('');
    };

    const isValid = uploadedImage.trim() || manualUrl.trim();

    return (
        <Box
            sx={{
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: 1,
                backgroundColor: '#fafafa',
                mb: 1,
            }}
        >
            {/* Upload Image Section */}
            <Box sx={{ mb: 2 }}>
                <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                    {t('image.upload', 'Upload Image')}
                </Typography>
                <UploadImageInput
                    multiple={false}
                    value={uploadedImage}
                    setFieldValue={handleUploadedImageChange}
                    title=""
                />
            </Box>

            {/* Manual URL Input */}
            <TextField
                label={t('image.imageUrl', 'Image URL')}
                type="url"
                fullWidth
                size="small"
                value={manualUrl}
                onChange={handleManualUrlChange}
                onBlur={() => setManualUrl(manualUrl.trim())}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                    }
                }}
                placeholder={t('image.imageUrlPlaceholder', 'https://example.com/image.jpg')}
                sx={{ mb: 2 }}
            />

            <Stack direction="row" spacing={1} justifyContent="flex-end">
                <Button onClick={onCancel} size="small">
                    {t('common.cancel', 'Cancel')}
                </Button>
                <Button variant="contained" size="small" disabled={!isValid} onClick={handleSubmit}>
                    {t('common.insert', 'Insert')}
                </Button>
            </Stack>
        </Box>
    );
};

export default InlineImageInput;
